import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { useSuccessPopupStyles } from './useSuccessPopupStyles';
import tick from '../images/successTick.png';

const SuccessPopup = props => {
    const classes = useSuccessPopupStyles();

    const handleProceed = () => {
        if (props.prepay) {
            window.location.href = `/prepay/dashboard`;
        } else {
            window.location.href = `/account/dashboard`;
        }
    };

    return (
        <>
            <Modal
                className={classes.successMain}
                wrapClassName={classes.successMainWrapper}
                modalClassName={classes.successMainModal}
                backdropClassName={classes.successMainBackDrop}
                contentClassName={classes.successMainContent}
                isOpen={true}
                toggle={true}
                modalTransition={{ timeout: 300 }}
                centered
            >
                <ModalBody className={classes.successWrapper}>
                    <div className={classes.registerTitleContainer}>
                        <div className={classes.registerTitle}>You're all set</div>
                    </div>
                    <div className={classes.successBody}>
                        <div className={classes.tickWrapper}>
                            <img className={classes.tick} src={tick} alt='' />
                        </div>
                        <div className={classes.newsTextWrapper}>
                            <div className={classes.newsText}>{props.text}</div>
                        </div>
                    </div>
                    <div className={classes.successFooter}>
                        <button
                            tabindex='0'
                            className={'primary-cta footer-cta'}
                            onClick={handleProceed}
                            aria-label='close-pop-up window'
                            role='button'
                        >
                            Proceed to my account
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default SuccessPopup;
